import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./AlertPrint'));

function LoadableAlertPrint() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableAlertPrint;
